<template>
  <svg
    width="32"
    height="45"
    viewBox="0 0 32 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="app-spinner"
  >
    <path
      d="M1.8 29.8742C1.13333 28.6742 0.666666 27.4659 0.4 26.2492C0.133333 25.0326 0 23.7909 0 22.5242C0 18.1576 1.575 14.3992 4.725 11.2492C7.875 8.09922 11.6333 6.52422 16 6.52422H18.15L14.15 2.52422L16.1 0.574219L23.55 8.02422L16.1 15.4742L14.1 13.4742L18.05 9.52422H16C12.4333 9.52422 9.375 10.7992 6.825 13.3492C4.275 15.8992 3 18.9576 3 22.5242C3 23.4909 3.09167 24.4076 3.275 25.2742C3.45833 26.1409 3.68333 26.9576 3.95 27.7242L1.8 29.8742ZM15.8 44.4242L8.35 36.9742L15.8 29.5242L17.75 31.4742L13.75 35.4742H16C19.5667 35.4742 22.625 34.1992 25.175 31.6492C27.725 29.0992 29 26.0409 29 22.4742C29 21.5076 28.9167 20.5909 28.75 19.7242C28.5833 18.8576 28.3333 18.0409 28 17.2742L30.15 15.1242C30.8167 16.3242 31.2917 17.5326 31.575 18.7492C31.8583 19.9659 32 21.2076 32 22.4742C32 26.8409 30.425 30.5992 27.275 33.7492C24.125 36.8992 20.3667 38.4742 16 38.4742H13.75L17.75 42.4742L15.8 44.4242Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ fill?: string }>(), { fill: '#912B8D' })
</script>

<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.app-spinner {
  animation: spin 1.6s linear infinite;
}
</style>
